import { render, staticRenderFns } from "./TableStat.vue?vue&type=template&id=202d7756&scoped=true&"
import script from "./TableStat.vue?vue&type=script&lang=js&"
export * from "./TableStat.vue?vue&type=script&lang=js&"
import style0 from "./TableStat.vue?vue&type=style&index=0&id=202d7756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202d7756",
  null
  
)

export default component.exports